import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { MenuItem, MessageService, TreeNode } from 'primeng/api';
import { UserManagementService } from 'app/services/user-management.service';
import { AppDataService } from 'app/services';
import * as moment from 'moment/moment';

enum MenuTab {
    Privileges = 1,
    AllUsers = 2,
    Details = 3,
}

@Component({
    selector: 'user-managment-roles-details',
    templateUrl: './user-managment-roles-details.component.html',
    styleUrls: ['./user-managment-roles-details.component.scss']
})
export class UserManagmentRolesDetailsComponent implements OnInit {

    mItems: MenuItem[] | undefined;

    @Output()
    changedVisibleDetailEmit = new EventEmitter<boolean>();

    @Input()
    set _visibleDetail(value: boolean) {
        this.visibleRolesDetail = value;
    }

    @Input()
    set _selectedRole(value: any) {
        this.selectedRole = value;
        this.getPermissions();
        this.getUsers();
    }

    get isRoleExist() {
        return this.selectedRole && this.selectedRole.Id;
    }

    get menuItems(): MenuItem[] {
        if (!this.isRoleExist) {
            return [
                {
                    label: 'Details',
                    command: (e: any) => this.handleTabChange(MenuTab.Details)
                }
            ];
        } else {
            return [
                {
                    label: 'Privileges',
                    command: (e: any) => this.handleTabChange(MenuTab.Privileges)
                },
                {
                    label: 'All Users',
                    command: (e: any) => this.handleTabChange(MenuTab.AllUsers)
                }
            ];
        }
    }


    users: Array<any> = [];
    permissions!: TreeNode[];
    visibleRolesDetail: boolean = false;
    selectedRole: any = undefined;

    menuTab = MenuTab;
    activeTab: MenuTab = MenuTab.Privileges;
    displayConfirmDialog: boolean = false;

    constructor(
        private messageService: MessageService,
        private userManagementService: UserManagementService,
        public appData: AppDataService) {
    }

    ngOnInit() {
        this.mItems = this.menuItems;
    }

    changedVisibleDetail(increased: any) {
        this.changedVisibleDetailEmit.emit(increased);
    }

    confirmAction() {
        if (this.isRoleExist) {
            this.updatePermissions();
        } else {
            this.createRole();
        }
    }

    createRole() {
        if (this.selectedRole) {
            const dto = {
                RoleName: this.selectedRole.Name,
                Permissions: this.extractPermissionData(this.permissions)
            };
            this.userManagementService.createRole(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
                        return;
                    }
                    this.messageService.add({severity: 'success', summary: 'Success', detail: 'Role has been created'});
                    this.displayConfirmDialog = false;
                    this.changedVisibleDetail(true);
                })
                .catch(err => {
                    this.messageService.add({severity: 'error', summary: 'Error', detail: err});
                    this.displayConfirmDialog = false;
                });
        }
    }

    getUsers() {
        if (this.isRoleExist) {
            const dto = {
                RoleId: this.selectedRole.Id
            };
            this.userManagementService.getUsers(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
                        return;
                    }
                    this.users = data.Items;
                    this.users.forEach(item => {
                        item.CreatedAt = moment(item.CreatedAt).format('DD MMM YYYY');
                    });
                })
                .catch(err => {
                    this.messageService.add({severity: 'error', summary: 'Error', detail: err});
                });
        }
    }

    getPermissions() {
        if (this.selectedRole) {
            const dto = {
                RoleId: this.selectedRole?.Id
            };
            this.userManagementService.getPermissionsByRoleId(dto, this.messageService)
                .then(data => {
                    if (!data) {
                        return;
                    }
                    if (!data.Success) {
                        this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
                        return;
                    }
                    this.permissions = data.Items;
                })
                .catch(err => {
                    this.messageService.add({severity: 'error', summary: 'Error', detail: err});
                });
        }
    }

    updatePermissions() {
        if (this.selectedRole) {
            const dto = {
                RoleId: this.selectedRole.Id,
                RoleName: this.selectedRole.Name,
                Items: this.extractPermissionData(this.permissions)
            };
            this.userManagementService.updatePermissions(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
                        return;
                    }
                    this.messageService.add({severity: 'success', summary: 'Success', detail: 'Data has been updated'});
                    this.displayConfirmDialog = false;
                })
                .catch(err => {
                    this.messageService.add({severity: 'error', summary: 'Error', detail: err});
                    this.displayConfirmDialog = false;
                });
        }
    }

    extractPermissionData(treeNodes: TreeNode[], dataList: any[] = []): any[] {
        for (const node of treeNodes) {
            dataList.push(node.data);
            if (node.children) {
                this.extractPermissionData(node.children, dataList);
            }
        }
        return dataList;
    }

    cancel() {
        this.changedVisibleDetail(false);
    }

    handleTabChange(menuTab: MenuTab) {
        this.activeTab = menuTab;
    }

    showConfirmDialog() {
        this.displayConfirmDialog = !this.displayConfirmDialog;
    }

    changeConfirmDialogVisibility() {
        this.displayConfirmDialog = !this.displayConfirmDialog;
    }
}
